import Vue from 'vue';
import axios from "axios";

// 响应拦截器，提前预处理响应
axios.interceptors.response.use(
    response => {
      if (response.status == 203) {
       //有些错误返回203，后续再做处理
      }
      return response;
    },
    err => {
        if (err.response.status === 500) { // 后端抛的错误
          //TODO:暂时只处理有ErrorCode,和ExcptionSeqNo的错误，后续逐步将放开
          const res =err.response.data||{};
          if(res.Code && res.ExceptionSeqNo){
            //有错误码和异常编码的
            Vue.prototype.$alert(res.Message, '错误', {
              confirmButtonText: '确定',
              callback: () => {},
            });
            return Promise.reject(err.response.data);
          }
        }
    }
  );